import React from "react";
import InviteFlowStatusBadge from "./InviteFlowStatusBadge";

const RegistrationTable = ({ registrations, linkId, onApprove, onReject, approvalLoading }) => {
  if (!registrations || registrations.length === 0) {
    return <p className="inviteflow-empty">No registrations yet.</p>;
  }

  return (
    <div className="inviteflow-table-wrapper">
      <table className="inviteflow-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Guests</th>
            <th>Sub-Link</th>
            <th>Status</th>
            <th>Action By</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {registrations.map((reg) => (
            <tr key={reg.id} className={reg.linkSlug !== linkId ? "inviteflow-table__row--sublink" : ""}>
              <td>{reg.primaryName}</td>
              <td>{reg.primaryEmail}</td>
              <td>{reg.primaryPhone || "—"}</td>
              <td>{reg.totalGuests}</td>
              <td>
                {reg.linkSlug !== linkId ? (
                  <span className="inviteflow-table__sublink-badge" title={reg.linkSlug}>
                    {reg.linkName || reg.linkSlug}
                  </span>
                ) : (
                  <span className="inviteflow-table__own-badge">Own</span>
                )}
              </td>
              <td>
                <InviteFlowStatusBadge status={reg.status} />
              </td>
              <td>
                {reg.actionByName ? (
                  <span title={reg.actionAt}>
                    {reg.actionByName}
                  </span>
                ) : "—"}
              </td>
              <td>
                {reg.status === "pending" && (
                  <div className="inviteflow-table__actions">
                    <button
                      className="inviteflow-btn inviteflow-btn--approve"
                      onClick={() => onApprove(reg.id)}
                      disabled={approvalLoading === reg.id}
                    >
                      Approve
                    </button>
                    <button
                      className="inviteflow-btn inviteflow-btn--reject"
                      onClick={() => onReject(reg.id)}
                      disabled={approvalLoading === reg.id}
                    >
                      Reject
                    </button>
                  </div>
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default RegistrationTable;
